/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaHeading/view.blocks to change it.
import "DesignSystem/Fonts/Inter-100.css"
import "DesignSystem/Fonts/Inter-200.css"
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-500.css"
import "DesignSystem/Fonts/Inter-600.css"
import "DesignSystem/Fonts/Inter-700.css"
import "DesignSystem/Fonts/Inter-800.css"
import "DesignSystem/Fonts/Inter-900.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaHeading({
  children,
  viewPath = "/DesignSystem/TysiaHeading",
  color,
  lineHeight = "40px",
  letterSpacing,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  text = "Default text",
  textAlign = "left",
  width = "auto",
  maxWidth = "auto",
  textOverflow = "clip",
  order = "no",
  whiteSpace = "nowrap",
  hyphens = "none",
  level,
  weight
  
}) {
let dtTysiaheadingColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaHeading.color.primary.base'
        })
let colorOrdtTysiaheadingColorPrimaryBase = color ?? dtTysiaheadingColorPrimaryBase
  return (<React.Fragment
>
<span
  data-testid="TysiaHeading.Text"
  data-view-path={viewPath}
 title={text}
 style={{'--c-1-1Wdy7T': colorOrdtTysiaheadingColorPrimaryBase,'--ls-4-1Wdy7T': typeof letterSpacing === 'number' ? `${letterSpacing}px` : letterSpacing,'--mt-6-1Wdy7T': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-7-1Wdy7T': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-8-1Wdy7T': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-9-1Wdy7T': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ta-10-1Wdy7T': textAlign,'--w-11-1Wdy7T': typeof width === 'number' ? `${width}px` : width,'--mw-12-1Wdy7T': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--to-13-1Wdy7T': textOverflow,'--o-14-1Wdy7T': order,'--ws-15-1Wdy7T': whiteSpace,'--h-16-1Wdy7T': hyphens,'--fs-2-1Wdy7T': level === "h1" ? "28px" : level === "h2" ? "22px" : level === "h3" ? "18px" : level === "h4" ? "15px" : level === "h5" ? "12px" : level === "h6" ? "10px" : "28px",'--lh-3-1Wdy7T': level === "h1" ? "40px" : level === "h2" ? "34px" : level === "h3" ? "28px" : level === "h4" ? "20px" : level === "h5" ? "16px" : level === "h6" ? "16px" : lineHeight,'--fw-5-1Wdy7T': weight === "thin" ? 100 : weight === "extralight" ? 200 : weight === "light" ? 300 : weight === "regular" ? 400 : weight === "medium" ? 500 : weight === "semibold" ? 600 : weight === "bold" ? 700 : weight === "extrabold" ? 800 : weight === "black" ? 900 : 500}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}